import { LuPencilLine } from 'react-icons/lu';
import type { UiString } from '../../schema';

interface Props {
  row: UiString;
  onEdit: (row: UiString) => void;
}

// Edit-only — no delete (keys are app-defined; toggle isActive=false to
// retire). Mirrors TagRowActions shape exactly.
export function UiStringRowActions({ row, onEdit }: Props) {
  return (
    <div className="row-actions flex h-full items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onEdit(row)}
        aria-label={`Edit ${row.key}`}
        title="Edit"
        className="group flex h-8 w-8 shrink-0 items-center justify-center self-center rounded-lg bg-primary/[0.08] text-primary ring-1 ring-inset ring-primary/15 transition-all duration-200 hover:scale-110 hover:bg-primary hover:text-primary-foreground hover:shadow-[0_4px_12px_-2px_rgb(var(--color-primary)/0.4)]"
      >
        <LuPencilLine size={15} strokeWidth={2.2} />
      </button>
    </div>
  );
}
